<template>
  <div class="block">
    <ol
      :class="'text-neutral-700 [&>*:last-child]:text-neutral-900'"
      class="flex text-sm flex-wrap  [&>*:last-child]:font-bold"
    >
      <li>
        <a
          :href="localizeGlobalUrl('/')"
          class="hover:underline transition duration-150"
        >
          <span>{{ $t('app.online-vets') }}</span>
        </a>
      </li>
      <li
        v-for="(crumb, index) in trail"
        :key="index"
        class="flex flex-row"
      >
        <svg
          fill="currentColor"
          viewBox="0 0 20 20"
          :class="iconColor ?? 'text-bubblegum'"
          class="h-5 w-auto mx-2"
        >
          <path
            fill-rule="evenodd"
            d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
            clip-rule="evenodd"
          />
        </svg>
        <a
          v-if="crumb.url"
          :href="crumb.url"
          class="hover:underline transition duration-150"
        >
          <span>{{ crumb.name }}</span>
        </a>
        <span v-else>{{ crumb.name }}</span>
      </li>
    </ol>
  </div>
</template>

<script>
import LocalizesRoutes from '@/mixins/LocalizesRoutes';

export default {
  name: 'VetsterBreadcrumbs',

  mixins: [LocalizesRoutes],

  props: {
    iconColor: {
      type: String,
      default: null,
    },
    trail: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
